module.exports = __webpack_public_path__ + "img/imagen3.5c8c0bb8.png";